import { GATEWAY_URL, ACCESS_TOKEN } from '../constants';
import log from "tailwindcss/lib/util/log";

const request = (options, token, tenant) => {
  console.log({ options, token, tenant });
  const currentLang = localStorage.getItem('curLang');
  const headers = new Headers({
    'Content-Type': 'application/json',
    'Accept-Language': !currentLang ? 'vi-VN' : currentLang
  })
  if (token) {
    headers.append("Authorization", `Bearer ${token}`)
  }
  if (tenant) {
    headers.append("tenant-id", tenant)
  }
  const defaults = { headers: headers, credentials: "include" };
  options = Object.assign({}, defaults, options);
  return new Promise((resolve, reject) => {
    fetch(options.url, options)
      .then(response => {
        resolve(response);
      }
      ).catch(e => {
        reject(e)
      });
  })
};

export function getCurrentUser() {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return request({
    url: GATEWAY_URL + "/api/account",
    method: 'GET'
  });
}

export function login(loginRequest) {
  return request({
    url: GATEWAY_URL + "/api/sessions",
    method: 'POST',
    body: JSON.stringify(loginRequest)
  });
}

export function logout(loginRequest) {
  return request({
    url: GATEWAY_URL + '/api/logout',
    method: 'POST',
    body: JSON.stringify(loginRequest),
  });
}

export async function changeEmail(key) {
  return request({
    url:
      GATEWAY_URL +
      `/services/gateway/api/account/change-email/finish?key=${key}`,
    method: 'POST',
  });
}

export function changePass(activeRequest) {
  return request({
    url: GATEWAY_URL + "/api/account/create-first-time-password",
    method: 'PUT',
    body: JSON.stringify(activeRequest)
  });
}

export function forgotPassword(data) {
  return request({
    url: GATEWAY_URL + "/api/account/reset-password/init",
    method: 'POST',
    body: data
  });
}

// Kiểm tra key trong link đặt lại mật khẩu ngay khi mở trang (không đổi gì trên server).
// Gateway trả 400 khi key không tồn tại/hết hạn → 'invalid'. Lỗi khác (mất mạng,
// gateway chưa có API → 404...) trả 'unknown' để vẫn hiện form, vì finish sẽ kiểm tra lại.
export async function checkResetKey(key) {
  try {
    const response = await request({
      url: GATEWAY_URL + `/api/account/reset-password/check?key=${encodeURIComponent(key)}`,
      method: 'GET',
    });
    if (response.ok) return 'valid';
    return response.status === 400 ? 'invalid' : 'unknown';
  } catch (e) {
    return 'unknown';
  }
}

export function resetPassword(data) {
  return request({
    url: GATEWAY_URL + "/api/account/reset-password/finish",
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export async function activeAccount(key) {
  return request({
    url: GATEWAY_URL + `/api/active?key=${key}`,
    method: "GET",
  });
}

export function signup(data) {
  return request({
    url: GATEWAY_URL + "/api/register",
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export function registerOrg(data) {
  return request({
    url: GATEWAY_URL + "/api/tenants/register",
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export function getUserInfo(jwt) {
  return request({
    url: GATEWAY_URL + "/services/gateway/api/account",
    method: 'GET'
  },
    jwt
  );
}

export function queryByEntity(
  /** entity code */
  id,
  /** query data */
  data,
  token,
  tenantId,
) {

  return request({
    url: GATEWAY_URL + `/services/entity/api/entity-instances/code/${id}/find-by-code`,
    method: "POST",
    body: JSON.stringify({
      ...data,
      entityCode: id,
    })
  },
    token,
    tenantId);
}


export function createOrg(data, token) {
  return request({
    url: GATEWAY_URL + "/api/tenants",
    method: 'POST',
    body: JSON.stringify(data)
  }, token);
}

export function updateData(id, entityCode, data, token,
  tenantId) {
  return request({
    url: GATEWAY_URL + `/services/entity/api/entity-instances/code/${entityCode}/${id}`,
    method: 'PUT',
    body: JSON.stringify(data)
  }, token,
    tenantId);
}

export function invite(id, deviceId, deviceName, appVersion) {
  const params = new URLSearchParams();
  if (deviceId) params.append('deviceId', deviceId);
  if (deviceName) params.append('deviceName', deviceName);
  if (appVersion) params.append('appVersion', appVersion);
  
  const queryString = params.toString();
  const url = `${GATEWAY_URL}/services/org/api/invite/accept/${id}${queryString ? `?${queryString}` : ''}`;
  
  return request({
    url: url,
    method: "GET",
  });
}
export function getBuildInfo(domain) {
  return new Promise((resolve, reject) => {
    fetch(`${domain}/build_info.json?v=${new Date().getTime()}`)
      .then((s) => s.json())
      .then((s) => resolve(s))
      .catch((e) => {
        reject(e);
      });
  });
}
